import { DRAWER_ID_SUFFIX } from "@/atoms"

// Switches tab by clicking the real tab node rather than calling
// onChangeActiveKey, so the drawer runs its own onChange: the scroll reset, the
// Kai sync and the disabled-tab guard all come for free, and TabsDrawerTemplate
// stays untouched. Scoped to this drawer's own tab bar — several can be open.
export const changeTab = (drawerId: string | undefined, tab: string) => {
  const root = drawerId
    ? document.getElementById(`${drawerId}${DRAWER_ID_SUFFIX}`)
    : null

  root
    ?.querySelector(".ant-tabs-nav")
    ?.querySelector<HTMLElement>(`.ant-tabs-tab[data-node-key="${tab}"]`)
    ?.click()
}
